import { useDroppable } from "@dnd-kit/react";
import MovableProvider, {
  useMovableContext,
} from "components/Movables/MovableProvider";
import PieceView from "components/Movables/PieceView";
import { useOutletContext } from "react-router-dom";
import { TeamPuzzleSockAPIScopeState } from "sockapi/scope-specs/team-spec";
import { useRound } from "stores/NavStore";
import { useBox } from "stores/RoundStore";
import "./PieceOverlay.css";
import { AnimatePresence } from "framer-motion";
import { clsObj } from "client-util/util";

export function PieceOverlayInner() {
  const puzData = useOutletContext<TeamPuzzleSockAPIScopeState>();
  const ctx = useMovableContext();
  const boxId = puzData.puzName;

  const { pieceIds } = useBox(boxId);

  const { ref: dropRef } = useDroppable({
    accept: ["boxPiece"],
    id: boxId,
  });

  return (
    <div
      className={clsObj({
        "piece-overlay": true,
        [`round-${ctx.round?.slug.replaceAll("_", "-")}`]: true,
      })}
      ref={(ref) => {
        dropRef(ref);
      }}
    >
      <AnimatePresence>
        {pieceIds
          ? pieceIds.map((pieceId) => (
              <PieceView key={pieceId} boxId={boxId} pieceId={pieceId} />
            ))
          : null}
      </AnimatePresence>
    </div>
  );
}

export default function PieceOverlay({
  puzData,
}: {
  puzData: TeamPuzzleSockAPIScopeState;
}) {
  const round = useRound();
  if (round === null)
    throw new Error(
      "piece interface should only be rendered in round contexts"
    );
  const puzzle = {
    ...puzData,
    cols: puzData.cols ?? round.boxCols,
    rows: puzData.rows ?? round.boxRows,
  };

  return (
    <MovableProvider context={{ type: "puzzle", round, puzzle }}>
      <PieceOverlayInner />
    </MovableProvider>
  );
}
